import { Link, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useState } from "react";
import "../../styles/sidebar.css"; // Make sure your styles are imported

const Sidebar = () => {
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const user_role = Cookies.get("user_role");
  const username = Cookies.get("username");
  const isProfileSectionActive = [
  "/dashboard/profile",
  "/dashboard/reports",
  "/dashboard/subjects",
  "/dashboard/ideas",
].includes(pathname);
  const [profileOpen, setProfileOpen] = useState(isProfileSectionActive);

  const isActive = (path) => (pathname === path ? "active" : "");

  const toggleSidebar = () => setCollapsed(!collapsed);

  return (
    <div className="d-flex">
      <nav className={`sidebar d-flex flex-column flex-shrink-0 position-fixed ${collapsed ? "collapsed" : ""}`}>
        <button className="toggle-btn" onClick={toggleSidebar}>
          <i className="fas fa-chevron-left"></i>
        </button>


        <div className="nav flex-column">
           {/* Profile Dropdown */}
<div className="sidebar-dropdown">
  <div
    className={`sidebar-link p-3 d-flex align-items-center justify-content-between ${isProfileSectionActive ? "active" : ""}`}
    onClick={() => setProfileOpen(!profileOpen)}
    style={{ cursor: "pointer" }}
  >
    <div>
      <i className="fas fa-user me-3"></i>
      <span className="hide-on-collapse">پروفایل</span>
    </div>

    {!collapsed && (
      <i className={`fas fa-chevron-${profileOpen ? "up" : "down"}`} />
    )}
  </div>

  {profileOpen && (
    <div className="sidebar-submenu">
      <Link
        to="/dashboard/profile"
        className={`sidebar-sublink ${isActive("/dashboard/profile")}`}
      >
        پروفایل من
      </Link>

      <Link
        to="/dashboard/reports"
        className={`sidebar-sublink ${isActive("/dashboard/reports")}`}
      >
        گزارش‌های من
      </Link>

      <Link
        to="/dashboard/subjects"
        className={`sidebar-sublink ${isActive("/dashboard/subjects")}`}
      >
        موضوعات من
      </Link>

      {(user_role === "admin" ||
        user_role === "manager" ||
        user_role === "author") && (
        <Link
          to="/dashboard/ideas"
          className={`sidebar-sublink ${isActive("/dashboard/ideas")}`}
        >
          ایده‌ها
        </Link>
      )}
    </div>
  )}
</div>

          {(user_role === "admin" || user_role === "manager") && (
            <Link to="/dashboard/add-user" className={`sidebar-link text-decoration-none p-3 ${isActive("/dashboard/add-user")}`}>
              <i className="fas fa-user-plus me-3"></i>
              <span className="hide-on-collapse">افزودن کاربر</span>
            </Link>
          )}


          {(user_role === "admin" || user_role === "manager") && (
            <Link to="/dashboard/download-reports" className={`sidebar-link text-decoration-none p-3 ${isActive("/dashboard/download-reports")}`}>
              <i className="fas fa-download me-3"></i>
              <span className="hide-on-collapse">دانلود گزارش</span>
            </Link>
          )}

          {(username === "a_zabihollahpoor" || username === "f_rahiminezhad" || username === "rahino_admin" || user_role=== "author") && (
          <Link to="/dashboard/workhours" className={`sidebar-link text-decoration-none p-3 ${isActive("/dashboard/workhours")}`}>
            <i className="fas fa-clock me-3"></i>
            <span className="hide-on-collapse">ساعت کاری</span>
          </Link>
          )}
          {(user_role === "admin" || user_role === "manager" || username === "f_rahiminezhad") && (
           <Link to="/dashboard/users" className={`sidebar-link text-decoration-none p-3 ${isActive("/dashboard/users")}`}>
            <i className="fas fa-users me-3"></i>
           <span className="hide-on-collapse">لیست کاربران</span>
          </Link>
          )}
          {(user_role === "admin" || user_role=== "author") && (
          <Link to="/dashboard/activities" className={`sidebar-link text-decoration-none p-3 ${isActive("/dashboard/activities")}`}>
                <i className="fas fa-chart-pie me-3" /> 
                <span className="hide-on-collapse">گزارش ماهانه من</span>
          </Link>
          )}

          {/* My Tasks – all users */}
          {(user_role === "author") && (
          <Link
              to="/dashboard/tasks"
              className={`sidebar-link text-decoration-none p-3 ${isActive("/dashboard/tasks")}`}
          >
                  <i className="fas fa-tasks me-3"></i>
                  <span className="hide-on-collapse">تسک‌های من</span>
          </Link>
          )}

        {/* Task Management – manager/admin only */}
          {(user_role === "admin" || user_role === "manager") && (
          <Link
            to="/dashboard/task-management"
            className={`sidebar-link text-decoration-none p-3 ${isActive("/dashboard/task-management")}`}
          >
            <i className="fas fa-clipboard-list me-3"></i>
            <span className="hide-on-collapse">مدیریت تسک‌ها</span>
          </Link>
        )}
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
